import React, { Component } from "react";
import axios from "axios";
import addAccessTokenToUrl from "../../../Utils/Axios/addTokenToUrl";
import { SIDE_NAV_ITEMS, profileNav } from "../../../api-constant";
import EditProfile from "./EditProfile";
import NavBar from "../../NavBar/Navbar";
import Sidebar from "../../Sidebar/sidebar";
import ResponsiveSidebar from "../../Sidebar/Responsive/SideBar";
import profileFormData from "../../../Utils/FakeJSONs/basic-information-data.json";
import personalInfoData from "../../../Utils/FakeJSONs/professional-information-data.json";

let nameHasNumber = /\d+/;

export class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      profileData: [],
      qualificationdropDownData: [],
      industrydropDownData: [],
      CountryData: [],
      disableField: true,
      hidButton: true,
      showEditIcon: false,
      fieldValidation: false,
      enableNotification: false,
      formData: profileFormData,
      firstName: "",
      lastName: "",
      altEmail: "",
      shortName: "",
      gender: "",
      dateOfBirth: null,
      Country: null,
      city: "",
      maritalStatus: "",
      maritalStatusId: null,
      occupation: "",
      companyName: "",
      industry: "",
      designation: "",
      qualification: "",
      workExperience: 0,
      tenureInCompany: 0,
      firstNameFieldValidation: false,
      lastNameFieldValidation: false,
      shortNameFieldValidation: false,
      genderFieldValidation: false,
      maritalStatusFieldValidation: false,

    };
  }

  componentDidMount() {
    const newUser = localStorage.getItem("new_user");
    if (newUser == "true") {
      this.setState({
        disableField: false,
        hidButton: false,
        showEditIcon: true,
      });
    }
    // profile data
    axios
      .get(addAccessTokenToUrl("/users/user/profile/view/"))
      .then((response) => {
        response.data.user.map((getData) => {
          this.setState({
            firstName: getData.first_name,
            lastName: getData.last_name,
            altEmail: getData.user_details__alter_email,
            shortName: getData.short_name,
            gender: getData.gender,
            dateOfBirth: getData.date_of_birth,
            Country: getData.country,
            city: getData.user_details__city,
            maritalStatus: getData.user_details__marital_status,
            maritalStatusId: this.getMaritalStatusId(getData.user_details__marital_status),
            occupation: getData.user_details__occupation,
            companyName: getData.company_name,
            industry: getData.user_details__industry__id,
            designation: getData.user_details__designation,
            qualification: getData.user_details__qualification__id,
            workExperience: getData.user_details__work_experience,
            tenureInCompany: getData.user_details__tenure_in_company,
            profileData: response.data.user,
          });
        });
      })
      .catch((error) => {
        console.error(error);
      });

    // Industry and Qualification Drop-Down Options
    axios
      .get(addAccessTokenToUrl("/masters/demographic/list/data/"))
      .then((response) => {
        this.setState({
          qualificationdropDownData: response.data.results[1],
          industrydropDownData: response.data.results[0],
        });
      })
      .catch((error) => {
        console.error(error);
      });

    // Countries List
    axios
      .get(addAccessTokenToUrl("/masters/country/list/"))
      .then((response) => {
        this.setState({
          CountryData: response.data.country_list,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleEnableField = () => {
    this.setState({
      disableField: false,
      hidButton: false,
      showEditIcon: true,
    });
  };

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };

  getMaritalStatusId = (status) => {
    const maritalStatusOptions = this.state.formData.find(item => item.formLabel === "Marital Status").dropdownOptions;
    const option = maritalStatusOptions.find(opt => opt.options === status);
    return option ? option.status_Id : null;
  }




  basicInfoSelect = (getselectValue, getIndex) => {
    if (getIndex === 3) {
      this.setState({
        altEmail: getselectValue,
      });
    }
    if (getIndex === 5) {
      this.setState({
        gender: getselectValue,
      });
    }
    if (getIndex === 6) {
      this.setState({
        dateOfBirth: getselectValue,
      });
    }
    if (getIndex === 7) {
      this.setState({
        Country: getselectValue,
      });
    }
    if (getIndex === 8) {
      this.setState({
        city: getselectValue,
      });
    }
    if (getIndex === 9) {
      this.setState({
        maritalStatus: getselectValue.text,
        maritalStatusId: getselectValue.value,
        maritalStatusFieldValidation: false,
      });
  

    }

  };

  professionalSelect = (getValue, getIndex) => {
    if (getIndex === 0) {
      this.setState({
        occupation: getValue,
      });
    }
    if (getIndex === 1) {
      this.setState({
        companyName: getValue,
      });
    }
    if (getIndex === 2) {
      this.setState({
        industry: getValue,
      });
    }
    if (getIndex === 3) {
      this.setState({
        designation: getValue,
      });
    }
    if (getIndex === 4) {
      this.setState({
        qualification: getValue,
      });
    }
    if (getIndex === 5) {
      this.setState({
        workExperience: getValue,
      });
    }
    if (getIndex === 6) {
      this.setState({
        tenureInCompany: getValue,
      });
    }
  };
  handleFormInput = (getInputValue, getInputFieldIndex) => {
    if (getInputFieldIndex === 0) {
      this.setState({
        firstName: getInputValue,
        fieldValidation: false,
      });
    }
    if (getInputFieldIndex === 1) {
      this.setState({
        lastName: getInputValue,
        fieldValidation: false,
      });
    }
    if (getInputFieldIndex === 4) {
      this.setState({
        shortName: getInputValue,
        fieldValidation: false,
      });
    }

    if (
      nameHasNumber.test(
        this.state.firstName,
        this.state.lastName,
        this.state.shortName
      ) == true
    ) {
      this.setState({
        fieldValidation: true,
      });
    }
  };

  handleFieldValidation = (e) => {
    e.preventDefault();
  
    let isValid = true;
  
    if (
      this.state.firstName == null ||
      this.state.firstName == "" ||
      this.state.firstName.length == 0
    ) {
      this.setState({
        firstNameFieldValidation: true,
      });
      isValid = false;
    } else {
      this.setState({
        firstNameFieldValidation: false,
      });
    }
  
    if (
      this.state.lastName == null ||
      this.state.lastName == "" ||
      this.state.lastName.length == 0
    ) {
      this.setState({
        lastNameFieldValidation: true,
      });
      isValid = false;
    } else {
      this.setState({
        lastNameFieldValidation: false,
      });
    }
  
    if (
      this.state.shortName == null ||
      this.state.shortName == "" ||
      this.state.shortName.length == 0
    ) {
      this.setState({
        shortNameFieldValidation: true,
      });
      isValid = false;
    } else {
      this.setState({
        shortNameFieldValidation: false,
      });
    }
  
    if (
      this.state.gender == "" ||
      this.state.gender == null ||
      this.state.gender.length == 0
    ) {
      this.setState({
        genderFieldValidation: true,
      });
      isValid = false;
    } else {
      this.setState({
        genderFieldValidation: false,
      });
    }
  
    if (!this.state.maritalStatusId) {
      this.setState({
        maritalStatusFieldValidation: true,
      });
      isValid = false;
    } else {
      this.setState({
        maritalStatusFieldValidation: false,
      });
    }
  
    if (isValid) {
      // Proceed with form submission
      axios
        .post(
          addAccessTokenToUrl("/users/update/user/account/informationnew/"),
          {
            country: this.state.Country,
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            company_name: this.state.companyName,
            gender: this.state.gender,
            short_name: this.state.shortName,
          }
        )
        .then(() => {
          localStorage.setItem("Gender", this.state.gender);
          localStorage.setItem("user_name", this.state.shortName);
          localStorage.setItem("new_user", "false");
  
          this.props.history.push({
            pathname: "/new/app/dashBoard",
          });
        })
        .catch((error) => {
          console.error(error);
        });
  
      axios
        .post(addAccessTokenToUrl("/users/update/user/basic/informationnew/"), {
          city: this.state.city,
          alter_email: this.state.altEmail,
          occupation: this.state.occupation,
          industry: this.state.industry,
          qualification: this.state.qualification,
          marital_status: this.state.maritalStatusId,
          tenure_in_company: this.state.tenureInCompany,
          work_experience: this.state.workExperience,
          designation: this.state.designation,
        })
        .then(() => {})
        .catch((error) => {
          console.error(error);
        });
  
      axios
        .post(addAccessTokenToUrl("/users/update/user/dob/information/"), {
          date_of_birth: this.state.dateOfBirth,
        })
        .then()
        .catch((error) => {
          console.error(error);
        });
    }
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };
  handleCloseNotification = () => {
    this.setState({
      enableNotification: false
    })
  }
  render() {
    const fullName = localStorage.getItem("full_name");
    const shortName = localStorage.getItem("short_name");
    /* check if full name and short name exists if not then render the sidenav component with props profile nav */
    const renderSideNav = () => {
      if (
        (fullName == "null" || fullName == "") &&
        (shortName == "null" || shortName == "")
      ) {
        return <Sidebar items={profileNav} />;
      } else {
        return <Sidebar items={SIDE_NAV_ITEMS} />;
      }
    };

    return (
      <div>
        <NavBar
          enableNotification={this.state.enableNotification}
          handleNotification={this.handleNotification}
          handleCloseNotification={this.handleCloseNotification}
        />
        {renderSideNav()}
        <ResponsiveSidebar
          items={profileNav}
          selectedSideNav={this.state.selectedSideNav}
          sidebarOpen={this.state.sidebarOpen}
          onSetSidebarOpen={this.onSetSidebarOpen}
        />

        <EditProfile
          profileData={this.state.profileData}
          industrydropDownData={this.state.industrydropDownData}
          qualificationdropDownData={this.state.qualificationdropDownData}
          CountryData={this.state.CountryData}
          profileFormData={this.state.formData}
          personalInfoData={personalInfoData}
          handleFieldValidation={this.handleFieldValidation}
          fieldValidation={this.state.fieldValidation}
          handleFormInput={this.handleFormInput}
          disableField={this.state.disableField}
          hidButton={this.state.hidButton}
          showEditIcon={this.state.showEditIcon}
          handleEnableField={this.handleEnableField}
          basicInfoSelect={this.basicInfoSelect}
          professionalSelect={this.professionalSelect}
          firstNameFieldValidation={this.state.firstNameFieldValidation}
          lastNameFieldValidation={this.state.lastNameFieldValidation}
          shortNameFieldValidation={this.state.shortNameFieldValidation}
          genderFieldValidation={this.state.genderFieldValidation}
          maritalStatus={this.state.maritalStatus}
          maritalStatusId={this.state.maritalStatusId}
          maritalStatusFieldValidation={this.state.maritalStatusFieldValidation}

        />
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/new/Components/View-Or-Edit-profile/EditProfile/index.jsx